import { createSelector } from "@reduxjs/toolkit";
import { UpgradePlanText } from "@src/components/LimitAccess/access-text";
import { isExperienceMultiCurrencyTest } from "@src/store/slices/experiences/selectors/currency/isMultiCurrencyTest";
import { isExperienceDuplicateProductsPriceTest } from "@src/store/slices/experiences/selectors/price/isDuplicateProductsPriceTest";
import { isExperienceShippingTest } from "@src/store/slices/experiences/selectors/shipping/isShippingTest";
import { Experience } from "@src/store/slices/experiences/types";
import { getConfiguration } from "@src/store/slices/organization/selectors/getConfiguration";

export const getScheduleExperienceInfo = (
  experience: Experience,
  historySuccess: boolean
) =>
  createSelector(
    getConfiguration<boolean>("enable_schedule_tests"),
    isExperienceShippingTest(experience),
    isExperienceMultiCurrencyTest(experience),
    isExperienceDuplicateProductsPriceTest(experience),
    (
      scheduleTestsEnabled,
      experienceShippingTest,
      experienceMultiCurrencyTest,
      experienceDuplicateProductsPriceTest
    ) => {
      if (!scheduleTestsEnabled) {
        return {
          showDialog: false,
          reason: UpgradePlanText,
        };
      }
      if (experience.status === "ended") {
        return {
          showDialog: false,
          reason: "Ended tests cannot be scheduled",
        };
      }
      if (!historySuccess) {
        return {
          showDialog: false,
          reason: "",
        };
      }
      if (experienceShippingTest) {
        return {
          showDialog: false,
          reason: "Shipping tests can not be scheduled",
        };
      }
      if (experienceMultiCurrencyTest) {
        return {
          showDialog: false,
          reason: "Multi currency tests can not be scheduled",
        };
      }
      if (experienceDuplicateProductsPriceTest) {
        return {
          showDialog: false,
          reason: "Price tests with duplicate products can not be scheduled",
        };
      }
      return { showDialog: true };
    }
  );
